import React from 'react';

/**
 * TipTapContent - Efficiently renders TipTap HTML content with consistent styling
 * This component uses simple HTML rendering instead of initializing a full TipTap editor instance
 * which is much more performant for read-only content display
 */
export const TipTapContent = ({ content, className = '' }) => {
  return (
    <>
      <div
        className={`tiptap-content prose prose-sm max-w-none ${className}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <style>{`
        /* Base TipTap content styles - matches the editor output */
        .tiptap-content {
          line-height: 1.6;
        }

        .tiptap-content h1 {
          font-size: 2em;
          font-weight: bold;
          margin: 0.67em 0;
        }

        .tiptap-content h2 {
          font-size: 1.5em;
          font-weight: bold;
          margin: 0.75em 0;
        }

        .tiptap-content h3 {
          font-size: 1.17em;
          font-weight: bold;
          margin: 0.83em 0;
        }

        .tiptap-content ul,
        .tiptap-content ol {
          padding-left: 1.5rem;
          margin: 0.5rem 0;
        }

        .tiptap-content ul {
          list-style-type: disc;
        }

        .tiptap-content ol {
          list-style-type: decimal;
        }

        .tiptap-content li {
          margin: 0.25rem 0;
        }

        .tiptap-content li p {
          margin: 0;
        }

        .tiptap-content a {
          color: hsl(var(--primary));
          text-decoration: underline;
          cursor: pointer;
        }

        .tiptap-content a:hover {
          opacity: 0.8;
        }

        .tiptap-content code {
          background-color: hsl(var(--muted));
          padding: 0.2em 0.4em;
          border-radius: 3px;
          font-size: 0.9em;
          font-family: monospace;
        }

        .tiptap-content pre {
          background-color: hsl(var(--muted));
          padding: 0.75rem;
          border-radius: 0.5rem;
          overflow-x: auto;
          margin: 0.5rem 0;
        }

        .tiptap-content pre code {
          background-color: transparent;
          padding: 0;
          font-size: 0.875rem;
          color: inherit;
        }

        .tiptap-content blockquote {
          border-left: 3px solid hsl(var(--border));
          padding-left: 1rem;
          margin-left: 0;
          margin-right: 0;
          font-style: italic;
          color: hsl(var(--muted-foreground));
        }

        .tiptap-content hr {
          border: none;
          border-top: 2px solid hsl(var(--border));
          margin: 1.5rem 0;
        }

        .tiptap-content strong {
          font-weight: bold;
        }

        .tiptap-content em {
          font-style: italic;
        }

        .tiptap-content u {
          text-decoration: underline;
        }

        .tiptap-content s {
          text-decoration: line-through;
        }

        .tiptap-content p {
          margin: 0.5em 0;
        }

        .tiptap-content p:first-child {
          margin-top: 0;
        }

        .tiptap-content p:last-child {
          margin-bottom: 0;
        }

        /* Text alignment */
        .tiptap-content [style*="text-align: left"] {
          text-align: left;
        }

        .tiptap-content [style*="text-align: center"] {
          text-align: center;
        }

        .tiptap-content [style*="text-align: right"] {
          text-align: right;
        }

        .tiptap-content [style*="text-align: justify"] {
          text-align: justify;
        }
      `}</style>
    </>
  );
};
